<template>
<div>
    <HeaderPurchase header="สร้างรายการใบสั่งซื้อ" :img_header="header_image" link_back="purchase"/>
    <AddPurchaseOrder/>
</div>
</template>

<script>
import HeaderImage from '@/assets/compliance.png'
import HeaderPurchase from "@/components/admin/purchase/headerpurchase/HeaderPurchase.vue";
import AddPurchaseOrder from "@/components/admin/purchase/AddPurchaseOrder.vue";

export default {
    name: "AddPurchase",
    components: {
        HeaderPurchase,
        AddPurchaseOrder,
    },
        data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>

<style scoped>

</style>
